import { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router';
import { routes } from 'client/lib/routes';
import { Channel } from 'client/model/skill';

export const useIsDraft = (channel: Channel, installableAppId = '') => {
    const { pathname } = useLocation();
    const history = useHistory();
    const isDraft = (pathname || '').startsWith(
        routes.app.installableAppSettings(channel, true, 'main', installableAppId),
    );
    const setIsDraft = useCallback(
        (isDraftUpdated: boolean, channel: Channel) => {
            history.push(
                `${routes.app.installableAppPage(channel, isDraftUpdated, 'settings', installableAppId)}/main`,
            );
        },
        [channel, installableAppId, history],
    );
    return { isDraft, setIsDraft };
};
